<template>
  <div>
    <sub-content-container :title="$t('aboutMe.abilities.pageLabel')">
      <ability v-for="(ability, i) in completeAbilities" :ability="ability" :key="`ability-${i}`" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const Ability = () =>
  import(/* webpackChunkName: "AbilitiesPage" */ "@/components/AboutMe/Ability.vue");

export default {
  name: "Abilities",
  components: {
    SubContentContainer,
    Ability
  },
  data() {
    return {
      abilities: [
        {
          // Programming languages
          stock: [
            {
              name: "JavaScript",
              logotype: "/img/languageLogotype/javascript.png",
              backgroundColor: "black"
            },
            {
              name: "CSS",
              logotype: "/img/languageLogotype/css.png"
            },
            {
              name: "HTML",
              logotype: "/img/languageLogotype/html.png"
            },
            {
              name: "SQL",
              logotype: "/img/languageLogotype/sql.png"
            },
            {
              name: "PHP",
              logotype: "/img/languageLogotype/php.png",
              backgroundColor: "black"
            },
            {
              name: "C",
              logotype: "/img/languageLogotype/c.png"
            },
            {
              name: "C++",
              logotype: "/img/languageLogotype/cplusplus.png"
            }
          ]
        },
        {
          // Programming systems, frameworks and libraries
          stock: [
            {
              name: "Vue (JavaScript)",
              logotype: "/img/languageLogotype/vue.png"
            },
            {
              name: "Nuxt (JavaScript, Vue)",
              logotype: "/img/languageLogotype/nuxt.png",
              backgroundColor: "black"
            },
            {
              name: "Gridsome (JavaScript, Vue)",
              logotype: "/img/languageLogotype/gridsome.png",
              backgroundColor: "black"
            },
            {
              name: "Vuetify (JavaScript, Vue)",
              logotype: "/img/languageLogotype/vuetify.png",
              backgroundColor: "black"
            },
            {
              name: "React (JavaScript)",
              logotype: "/img/languageLogotype/react.jpg"
            },
            {
              name: "Angular (JavaScript)",
              logotype: "/img/languageLogotype/angular.png"
            },
            {
              name: "JQuery (JavaScript)",
              logotype: "/img/languageLogotype/jquery.jpg"
            },
            {
              name: "ThreeJS (JavaScript)",
              logotype: "/img/languageLogotype/threejs.jpg"
            },
            {
              name: "Aframe (JavaScript, ThreeJS)",
              logotype: "/img/languageLogotype/aframe.png"
            },
            {
              name: "NodeJS (JavaScript)",
              logotype: "/img/languageLogotype/nodejs.png"
            },
            {
              name: "Express (JavaScript, NodeJS)",
              logotype: "/img/languageLogotype/express.png"
            },
            {
              name: "NestJS (JavaScript, NodeJs)",
              logotype: "/img/languageLogotype/nestjs.png"
            },
            {
              name: "MongoDB (NoSQL)",
              logotype: "/img/languageLogotype/mongodb.png",
              backgroundColor: "black"
            },
            {
              name: "Firestore (GCP)",
              logotype: "/img/languageLogotype/gcp.jpeg"
            },
            {
              name: "MySQL (SQL)",
              logotype: "/img/languageLogotype/mysql.jpg"
            },
            {
              name: "Bootstrap (CSS, JQuery)",
              logotype: "/img/languageLogotype/bootstrap.png"
            },
            {
              name: "BootstrapVue (JavaScript, Vue, Bootstrap)",
              logotype: "/img/languageLogotype/bootstrapvue.png",
              backgroundColor: "black"
            },
            {
              name: "Codeigniter (PHP)",
              logotype: "/img/languageLogotype/codeigniter.png"
            }
          ]
        },
        {
          // Development tools
          stock: [
            {
              name: "NPM (NodeJS)",
              logotype: "/img/toolLogotype/npm.png"
            },
            {
              name: "GIT",
              logotype: "/img/toolLogotype/git.png"
            },
            {
              name: "Gitlab (GIT)",
              logotype: "/img/toolLogotype/gitlab.jpg"
            },
            {
              name: "Pipelines (Gitlab)",
              logotype: "/img/toolLogotype/gitlab.jpg"
            },
            {
              name: "Runners (Gitlab)",
              logotype: "/img/toolLogotype/gitlab.jpg"
            },
            {
              name: "Github (GIT)",
              logotype: "/img/toolLogotype/github.png"
            },
            {
              name: "Bitbucket (GIT, Atlassian)",
              logotype: "/img/toolLogotype/bitbucket.jpg"
            },
            {
              name: "Jira (Atlassian)",
              logotype: "/img/toolLogotype/jira.png"
            },
            {
              name: "Confluence (Atlassian)",
              logotype: "/img/toolLogotype/confluence.jpeg"
            },
            {
              name: "Shortcut",
              logotype: "/img/toolLogotype/shortcut.png",
              backgroundColor: "black"
            },
            {
              name: "Linear",
              logotype: "/img/toolLogotype/linear.png",
              backgroundColor: "black"
            },
            {
              name: "Netlify",
              logotype: "/img/toolLogotype/netlify.png"
            },
            {
              name: "S3 (AWS)",
              logotype: "/img/toolLogotype/aws.png"
            },
            {
              name: "EC2 (AWS)",
              logotype: "/img/toolLogotype/aws.png"
            },
            {
              name: "Cloudfront (AWS)",
              logotype: "/img/toolLogotype/aws.png"
            },
            {
              name: "Cloudflare",
              logotype: "/img/toolLogotype/cloudflare.png"
            },
            {
              name: "VS Code (IDE)",
              logotype: "/img/toolLogotype/vscode.jpeg"
            },
            {
              name: "Atom (IDE)",
              logotype: "/img/toolLogotype/atom.png"
            },
            {
              name: "Komodo (IDE)",
              logotype: "/img/toolLogotype/komodo.png"
            },
            {
              name: "MySQL Workbench (MySQL)",
              logotype: "/img/toolLogotype/mysqlworkbench.png"
            },
            {
              name: "TablePlus (MySQL UI)",
              logotype: "/img/toolLogotype/tableplus.png",
              backgroundColor: "black"
            }
          ]
        },
        {
          // Design and layout tools
          stock: [
            {
              name: "Canva",
              logotype: "/img/toolLogotype/canva.png",
              backgroundColor: "black"
            },
            {
              name: "Figma",
              logotype: "/img/toolLogotype/figma.png",
              backgroundColor: "black"
            },
            {
              name: "Photoshop",
              logotype: "/img/toolLogotype/photoshop.png",
              backgroundColor: "black"
            },
            {
              name: "App Diagrams (draw.io)",
              logotype: "/img/toolLogotype/drawio.png"
            }
          ]
        },
        {
          // UML diagrams
          stock: [
            {
              logotype: "/img/toolLogotype/uml.png",
              lastTimeUsed: "2018"
            },
            {
              logotype: "/img/toolLogotype/uml.png",
              lastTimeUsed: "2018"
            },
            {
              logotype: "/img/toolLogotype/uml.png",
              lastTimeUsed: "2018"
            },
            {
              logotype: "/img/toolLogotype/uml.png",
              lastTimeUsed: "2018"
            }
          ]
        },
        {
          // Languages
          stock: [
            {
              logotype: "/img/toolLogotype/usaflag.jpg",
              backgroundColor: "black"
            }
          ]
        }
      ]
    };
  },
  computed: {
    completeAbilities() {
      return this.abilities.map((data, i) => {
        const stock = [];

        if (data.stock && data.stock.length) {
          stock.push(...data.stock);
        }
        if (
          this.$t("aboutMe.abilities.skills")[i].stock &&
          this.$t("aboutMe.abilities.skills")[i].stock.length
        ) {
          stock.forEach((s, j) => {
            if (this.$t("aboutMe.abilities.skills")[i].stock[j]) {
              stock[j] = { ...s, ...this.$t("aboutMe.abilities.skills")[i].stock[j] };
            }
          });
        }

        return {
          ...data,
          ...this.$t("aboutMe.abilities.skills")[i],
          stock
        };
      });
    }
  }
};
</script>
